import { withOnClickTracking } from 'auto-tracking';
import { rem, styled, theme } from 'design-system';

export const Button = withOnClickTracking(
  styled('button', {
    backgroundColor: theme.colors.gray1,
    border: 'none',
    margin: 0,
    boxShadow: `${theme.shadows.border} ${theme.colors.gray8}, ${theme.shadows.shadow2} ${theme.colors.grayAlpha7}`,
    color: theme.colors.gray11,
    cursor: 'pointer',
    fontSize: rem(16),
    fontWeight: theme.fontWeights.medium,
    lineHeight: rem(24),
    textDecoration: 'none',

    '&:hover': {
      boxShadow: `${theme.shadows.border} ${theme.colors.gray8}, ${theme.shadows.shadow3} ${theme.colors.grayAlpha7}`,
    },

    '&:active': {
      backgroundColor: theme.colors.gray2,
      boxShadow: `${theme.shadows.border} ${theme.colors.gray8}, ${theme.shadows.shadow1} ${theme.colors.grayAlpha7}`,
    },

    '&:disabled': {
      boxShadow: `${theme.shadows.border} ${theme.colors.gray4}`,
      color: theme.colors.gray7,
      cursor: 'unset',
    },

    '&:focus-visible': {
      boxShadow: `${theme.shadows.border} ${theme.colors.gray8}, ${theme.shadows.shadow3} ${theme.colors.yellowAlpha7}`,
      outline: `2px solid ${theme.colors.yellow8}`,
      outlineOffset: '2px',
    },

    variants: {
      size: {
        tiny: {
          borderRadius: rem(4),
          fontSize: rem(12),
          paddingTop: rem(0),
          paddingRight: rem(6),
          paddingBottom: rem(0),
          paddingLeft: rem(6),
        },
        small: {
          borderRadius: rem(8),
          fontSize: rem(16),
          paddingTop: rem(12),
          paddingRight: rem(24),
          paddingBottom: rem(12),
          paddingLeft: rem(24),
        },
        big: {
          borderRadius: rem(10),
          fontSize: rem(19),
          paddingTop: rem(16),
          paddingRight: rem(32),
          paddingBottom: rem(16),
          paddingLeft: rem(32),
        },
      },
      fullWidth: {
        true: {
          width: '100%',
          textAlign: 'center',
        },
      },

      color: {
        gray1: {
          backgroundColor: theme.colors.gray1,
          color: theme.colors.gray11,
        },
        yellow: {
          backgroundColor: 'Yellow',
          color: 'Black',
        },
      },
    },

    defaultVariants: {
      size: 'small',
    },
  }),
);
